/**
 * Rounds value to one of [1, 5, 10] * 1eN
 * where N is order of magnitude (ie N in number 101 is 2);
 */
export function getRoundValue(value: number) {
  const minLimitTo = 2.5;
  const maxLimitFrom = 7.5;
  const absValue = Math.abs(value);
  const order = Math.floor(absValue).toString().length - 1;
  const sign = value < 0 ? -1 : 1;
  const mulFactor = 10 ** order;
  if (absValue < minLimitTo * mulFactor) {
    return sign * 1 * mulFactor;
  }
  if (absValue >= maxLimitFrom * mulFactor) {
    return sign * 10 * mulFactor;
  }
  return sign * 5 * mulFactor;
}

/**
 * Rounds a value to a specified precision.
 */
export function round(value: number, decimalDigits = 2) {
  return Math.round(value * 10 ** decimalDigits) / 10 ** decimalDigits;
}
